<h2 mat-dialog-title>Delete general role summary</h2>
<mat-dialog-content>
  <div class="subtitle">
    <span><mat-icon>error</mat-icon>Delete general role operation failed.</span>
  </div>
  <span>General role </span>
  <span style="font-weight: bold">{{ data[0]?.generalRole?.roleName }}</span>
  <span> is in use by following users:</span>
  <li *ngFor="let item of data">
    <span *ngIf="item?.user?.firstName || item?.user?.lastName; else email">
      {{ item?.user?.firstName }} {{ item?.user?.lastName }}
    </span>
    <ng-template #email>{{ item?.user?.email }}</ng-template>
  </li>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="warn" (click)="close()">Close</button>
</mat-dialog-actions>
